import { toNumber, isNumber, isInteger } from 'lodash';
/**
 * Format the price numbers as special currency type
 * @param {number | string} amount 800.01
 * @returns {{dollars: string, cents: string}} {dollors: 800, cents: 01} or {dollors: 1,800, cents: 01}
*/
const destructNumber = function (amount) {
    const amountNumber = toNumber(amount);
    if (!amountNumber || !isNumber(amountNumber)) {
        return undefined;
    }
    const dollars = Math.trunc(amountNumber).toLocaleString();
    const cents = isInteger(amountNumber) ? '00' : toFixedNumber(amountNumber).split('.')[1];
    return {
        dollars,
        cents
    };
};

const toFixedNumber = (amount) => {
    const amountNumber = toNumber(amount);
    if (!amountNumber || !isNumber(amountNumber)) {
        return undefined;
    }
    return amountNumber.toFixed(2);
};

const addCurrencySymbol = (amount) => {
    return (amount && !amount.toString().startsWith('$')) ? '$'.concat(amount) : amount;
};

const currencySymbol = '$';
const decimalPoint = '.';

export { destructNumber, toFixedNumber, addCurrencySymbol, currencySymbol, decimalPoint };
